export default __webpack_public_path__ + "static/44-f8f902dd2eeac20e4319c93c1c191f1d.png";